import React, { useContext } from 'react';
import UltimatePagination from 'react-ultimate-pagination-bootstrap-3';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import shortid from 'shortid';
import {
  Title,
  EmptyState,
  EmptyStateIcon,
  EmptyStateBody,
  Pagination,
  PaginationVariant,
} from '@patternfly/react-core';
import CatalogIcon from '@patternfly/react-icons/dist/esm/icons/catalog-icon';
import { CatalogLayout, useFeature } from '@ole-ui/ole-ui-components';
import SkillsPathCard from 'components/OfferingCards/SkillsPathCard';
import { EnablementFeatureFlags } from 'config/featureFlags';
import { storesContext } from '../../../stores';
import catalogPaginationPerPageOptions from '../../../views/Catalog/catalogPaginationOptions';
import LearningPathCard from '../Card';
import DeleteLearningPathModal from '../DeleteLearningPathModal';
import './styles.scss';

const LearningPathList = () => {
  const { learningPathStore } = useContext(storesContext);
  const { t } = useTranslation();
  const [isDeleteModalVisible, setDeleteModalVisibility] =
    React.useState(false);
  const {
    currentPage,
    paginatedEntries,
    setCurrentPage,
    filteredCount,
    entriesPerPage,
    totalPages,
  } = learningPathStore;
  const [pathToDelete, setPathToDelete] = React.useState(null);
  const newCatalogEnabled = useFeature({
    section: 'enablements',
    flagName: EnablementFeatureFlags.NewCatalog,
    defaultFlagValue: false,
  });

  if (newCatalogEnabled) {
    return (
      <div className="catalog__container">
        <CatalogLayout.Grid>
          <Pagination
            className="catalog__pagination catalog__pagination--top"
            itemCount={filteredCount}
            perPage={entriesPerPage}
            page={currentPage}
            onSetPage={(e, n) => setCurrentPage(n)}
            onPerPageSelect={(e, n) => {
              learningPathStore.entriesPerPage = n;
            }}
            perPageOptions={catalogPaginationPerPageOptions}
            widgetId="skills-paths-pagination-top"
            ouiaId="SkillsPathsPaginationTop"
            aria-label={t('Top pagination controls')}
            variant={PaginationVariant.bottom}
          />
          {paginatedEntries.map((entry) => (
            <SkillsPathCard key={entry.code} learningPath={entry} />
          ))}
          <Pagination
            className="catalog__pagination"
            itemCount={filteredCount}
            perPage={entriesPerPage}
            page={currentPage}
            onSetPage={(e, n) => setCurrentPage(n)}
            onPerPageSelect={(e, n) => {
              learningPathStore.entriesPerPage = n;
            }}
            perPageOptions={catalogPaginationPerPageOptions}
            widgetId="skills-paths-pagination-bottom"
            ouiaId="SkillsPathsPaginationBottom"
            aria-label={t('Bottom pagination controls')}
            variant={PaginationVariant.bottom}
          />
        </CatalogLayout.Grid>
      </div>
    );
  }
  return (
    <React.Fragment>
      {paginatedEntries.length ? (
        <React.Fragment>
          <div className="catalog__list">
            {paginatedEntries.map((entry) => {
              const { user_progress: userProgress } = entry;
              const progress = Math.round(userProgress * 100) || 0;
              return (
                <LearningPathCard
                  key={shortid.generate()}
                  learningPath={entry}
                  progress={progress}
                  onDeleteCSK={(cskToDelete) => {
                    if (cskToDelete && cskToDelete.code) {
                      setPathToDelete(cskToDelete);
                      setDeleteModalVisibility(true);
                    }
                  }}
                />
              );
            })}
          </div>
          <div className="catalog-list-pagination">
            <UltimatePagination
              currentPage={currentPage}
              totalPages={totalPages}
              onChange={setCurrentPage}
            />
          </div>
          {isDeleteModalVisible && (
            <DeleteLearningPathModal
              showModal={isDeleteModalVisible}
              pathToDelete={pathToDelete}
              onPathDeleted={() => {
                setDeleteModalVisibility(false);
                setPathToDelete(null);
              }}
            />
          )}
        </React.Fragment>
      ) : (
        <EmptyState>
          <EmptyStateIcon icon={CatalogIcon} />
          <Title size="lg" headingLevel="h4">
            {t('No skills paths found')}
          </Title>
          <EmptyStateBody>
            {t('Use the create button to make a custom skill path.')}
          </EmptyStateBody>
        </EmptyState>
      )}
    </React.Fragment>
  );
};
export default observer(LearningPathList);
